var React = require('react');

function QuestionMarksInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{opacity:0.66;}.cls-2{opacity:0.14;}.cls-3{font-size:348.47px;}.cls-3,.cls-4{fill:#fff;font-family:VanillaExtractRegular, Vanilla Extract;}.cls-4{font-size:184.04px;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"className":"cls-1"},[React.createElement("g",{"className":"cls-2","key":0},React.createElement("text",{"className":"cls-3","transform":"translate(41.22 307.89) rotate(16.37)"},"?")),React.createElement("g",{"className":"cls-2","key":1},React.createElement("text",{"className":"cls-4","transform":"translate(0 266.27)"},"?"))])))]);
}

QuestionMarksInline.defaultProps = {"viewBox":"0 0 343.57 462.87"};

module.exports = QuestionMarksInline;

QuestionMarksInline.default = QuestionMarksInline;
